"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectCreatable = MultiSelectCreatable;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _SelectIndicators = require("./SelectIndicators");

var _Field = require("./Field");

var _reactSelectUtilities = require("../utilities/reactSelectUtilities");

var _selectUtils = require("../utilities/selectUtils");

var _excluded = ["cssClassModifiers", "disabled", "errorMessage", "handleCreate", "isValid", "label", "reference", "textField", "valueField"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function MultiSelectCreatable(props) {
  var styles = (0, _react.useMemo)(function () {
    return (0, _reactSelectUtilities.getReactSelectStyles)(props.styles);
  }, [props.styles]);

  var cssClassModifiers = props.cssClassModifiers,
      disabled = props.disabled,
      errorMessage = props.errorMessage,
      handleCreate = props.handleCreate,
      isValid = props.isValid,
      label = props.label,
      reference = props.reference,
      textField = props.textField,
      valueField = props.valueField,
      remainingProps = _objectWithoutProperties(props, _excluded);

  return (
    /*#__PURE__*/
    _react["default"].createElement(_Field.Field, {
      cssClassModifiers: cssClassModifiers,
      disabled: disabled,
      errorMessage: errorMessage,
      isValid: isValid,
      label: label
    },
    /*#__PURE__*/
    _react["default"].createElement(_creatable["default"], _extends({}, remainingProps, {
      isMulti: true,
      className: "basic-multi-select",
      classNamePrefix: "select",
      components: {
        ClearIndicator: _SelectIndicators.ClearIndicator,
        DropdownIndicator: _SelectIndicators.DropdownIndicator
      },
      getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        var _ref;

        return _ref = {}, _defineProperty(_ref, textField, optionLabel), _defineProperty(_ref, valueField, inputValue), _ref;
      },
      getOptionLabel: function getOptionLabel(option) {
        return option[textField];
      },
      getOptionValue: function getOptionValue(option) {
        return option[valueField];
      },
      isDisabled: disabled,
      onCreateOption: handleCreate,
      ref: reference,
      styles: styles
    })))
  );
} // More information on react-select props:
// https://github.com/JedWatson/react-select/blob/b0411ff46bc1ecf45d9bca4fb58fbce1e57f847c/packages/react-select/src/types.js


MultiSelectCreatable.propTypes = {
  textField: _propTypes["default"].string.isRequired,
  valueField: _propTypes["default"].string.isRequired,
  cssClassModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string),
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Object), _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Object))]),
  disabled: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  filterOption: _propTypes["default"].func,
  handleCreate: _propTypes["default"].func,
  isClearable: _propTypes["default"].bool,
  isSearchable: _propTypes["default"].bool,
  isValid: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  menuPlacement: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  reference: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].instanceOf(Object)]),
  styles: _propTypes["default"].instanceOf(Object),
  value: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Object), _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Object))])
};
MultiSelectCreatable.defaultProps = {
  cssClassModifiers: [],
  disabled: false,
  errorMessage: '',
  filterOption: _selectUtils.defaultFilterOption,
  handleCreate: undefined,
  isClearable: true,
  isSearchable: true,
  isValid: true,
  label: '',
  menuPlacement: 'auto',
  placeholder: '',
  value: []
};